import {   FETCH_ACTIVE_SEASONS  } from '../../actions'

export default function seasonsettings (state,action) {   
    
    const {  payload } = action      
    
    switch(action.type) {
      
        case FETCH_ACTIVE_SEASONS: {           
            const { data } = payload
            if (data) { 

                const defaultSeason = payload.data[0]

                const defaultId   = parseInt(defaultSeason.id)
                const seasonyears = defaultSeason.description

                return Object.assign({},state,{
                        values: {
                            settingsseason:defaultId,
                            seasonyears
                        },
                        fields: {
                            settingsseason:defaultId,
                            seasonyears
                        }
                    }
                )
            }
            else {
                return state
            }
        }
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonsettings.js